<h3>Provider Info Requests</h3>
@if (!loading) {
  <div>
    @if (prescriberIncorrectInformationRequests.length > 0) {
      <section>
        <app-pagination-header
          [label]="'provider info requests'"
          [paging]="paging"
          (pageSizeChange)="onPageSizeChange($event)"
          />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>USER</th>
              <th>PRESCRIBER</th>
              <th>SPECIALTIES</th>
              <th>COMMENTS</th>
              <th>STATUS</th>
              <th>DATE REPORTED</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (request of prescriberIncorrectInformationRequests; track request; let i = $index) {
              <tr>
                <td>{{ request.client.humanizedName }}</td>
                <td>{{ request.submittedBy.fullName }}</td>
                <td><app-prescriber-name [provider]="request.provider" [linkToProvider]="true" /></td>
                <td>{{ request.provider.displaySpecialty }}</td>
                <td>{{ request.comments }}</td>
                <td>
                  @if (request.resolvedAt) {
                    <span>
                      Resolved ({{ request.resolvedBy.email }})
                    </span>
                  }
                  @if (!request.resolvedAt) {
                    <span>
                      New
                    </span>
                  }
                </td>
                <td>{{ request.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
                <td>
                  <ul class="nav">
                    <li class="nav-item">
                      @if (!request.resolvedAt) {
                        <a href="#" (click)="resolve($event, request)">
                          Resolve
                        </a>
                      }
                      @if (request.resolvedAt) {
                        <a href="#" (click)="unresolve($event, request)">
                          Cancel
                        </a>
                      }
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section><p>There are no provider info requests.</p></section>
    }
  </div>
} @else {
  <mat-spinner />
}
